// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"be9d27f5","209":"637302eb"}[chunkId] + ".chunk.css";
};